// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"q-","itemWrapper":"q_ p4","itemStyle":"ra p5"};